export const spinnerTypes = {
	SHOW: 'SHOW_SPINNER',
	HIDE: 'HIDE_SPINNER'
};